<template>
  <div class="SearchHistoryTableComponent DataTables">
    <p>{{lang.infotext_1}}:</p>
    <div v-show="!isData">
      <LoaderComponent  v-if="!isData"></LoaderComponent>
    </div>
    <div v-show="isData" :id="id"></div>



    </div>
</template>
<script>
  import LoaderComponent from "@/components/shared/LoaderComponent"
  import * as Tools from './../../Tools/Tools'

  import $ from 'jquery';
  import dt from 'datatables.net-bs4';

  export default {
      name: "SearchHistoryTableComponent",
      props:{

        lang: Object
      },
      components: {
        LoaderComponent
      },
      data () {
          return {
              mainTable: "",
              id: "SearchHistoryTableComponent",
              searchHistoryRaw: [],
              searchHistoryTable: []
          }
      },
      computed: {

        isData(){

          return this.searchHistoryTable.length != undefined
        },
        externalSearchResponseResult(){

          return this.$store.getters.externalSearchResponseResult;

        },
      },
      created () {

        this.getSearchHistory();

      },
      watch: {
        externalSearchResponseResult: function (newVal, oldVal) {


          if (newVal.length > 0){

            if (newVal[0].Quantity != undefined){
              this.getSearchHistory();
            }
          }



        }

      },
      updated() {

      },
      methods: {
        getSearchHistory(){
          let vue = this;
          this.$store.dispatch(this.$store.getters.sectionPrefix + "_getSearchHistory")
          .then((result) => {
            console.log(result)
            if (result.status == "OK"){
              vue.searchHistoryRaw = result.data;

              this.createHistoryTable();
            }

          })
        },
        createHistoryTable(){

          this.searchHistoryTable = [];

          for (let i = 0, lei = this.searchHistoryRaw.length; i < lei; i++){

            let suppliers = [];
            let ids = [];
            for (let j = 0, lej = this.searchHistoryRaw[i].searched.length; j < lej; j++){
              ids.push(this.searchHistoryRaw[i].searched[j].searchId);
              suppliers.push(this.searchHistoryRaw[i].searched[j].provider)
            }

            let obj = {
              id: ids,
              date: this.searchHistoryRaw[i].searchDate,
              string: this.searchHistoryRaw[i].searchString,
              supplier: suppliers
            }
            this.searchHistoryTable.push(obj);
          }


          this.buildTable();
        },
        buildTable(){
          


          var tableplace = document.getElementById(this.id);
          if (tableplace == null) {
            return;
          }
          while (tableplace.firstChild) {
              tableplace.removeChild(tableplace.firstChild);
          }

          var table = document.createElement("table");
          table.setAttribute("id", "t_"+this.id);
          table.setAttribute("class", "table table-striped table-bordered");
          tableplace.appendChild(table)

          var tr = document.createElement("tr");
          tr.setAttribute("class", "cellHeader");
          var thead = document.createElement("thead");
          thead.appendChild(tr);
          table.appendChild(thead);

          var _vue = this;

          let columns = [
            {
              name: "Id",
              alignInColumn: "left",

            },
            {
              name: this.lang.table_header_Date,
              alignInColumn: "left",

            },
            {
              name: this.lang.table_header_Supplier,
              alignInColumn: "left",

            },
            {
              name: this.lang.table_header_String,
              alignInColumn: "left",
              dataObject: "1"
            },

          ]

          let cols =  [
            { "data": "id" },
            { "data": "date" },
            { "data": "supplier" },
            { "data": "string" },


          ]


          let columnDefs = [];
          var len = columns.length;
          for (var i = 0; i < len; i++){

            var el = {};

            var classname = '_dt-body-'+ columns[i].alignInColumn;

            el = {
              targets: i,
              className: classname,

              render: function ( data, type, row, meta ) {
                if (data == null) {
                  data = "";
                }

                data = $.fn.dataTable.render.text().display(data);
                if (data.display != undefined) {
                  data.display = $.fn.dataTable.render.text().display(data.display);
                }

                if(meta.col == 0){

                  return  data;

                }
                if (meta.col == 1){



                  return Tools.longDateToShort(data);
                }
                if (meta.col == 2) {

                  return data;
                }
                if (meta.col == 3) {
                  return data;
                }

              }

            }

            columnDefs.push(el);


            var th = document.createElement("th");
            tr.appendChild(th);
            var br = document.createElement("br");
            th.appendChild(br);

            var tx = document.createTextNode(columns[i].name)
            th.appendChild(tx);

          }


          var json = {};
          json.paging = false;
          json.info = false;
          json.dom = 'f<t>';
          json.data= this.searchHistoryTable;
          json.myColumnFormats = columns;
          json.select = true;
          json.order = [[1, "desc"]];

          json.columns = cols;

          json.columnDefs = columnDefs;
          json.initComplete = function () {


            console.log("complete")

          }




          if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
              this.mainTable.destroy();
              console.log("DESTROY TABLE")
          }

          var _vue = this;

          this.mainTable = $('#t_'+this.id).DataTable(json);

          this.mainTable.columns.adjust().draw();

          //hide first column in table
          this.mainTable.column( 0 ).visible( false );

          //search input change view
          var searchplace = document.getElementById("t_"+this.id + "_filter").firstChild

          while (searchplace.firstChild) {

            if (searchplace.firstChild.textContent == "Search:"){
                searchplace.removeChild(searchplace.firstChild);
                break;
            }

          }
          searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
          searchplace.firstChild.setAttribute("class", "form-control form-control-sm");


          let _mainTable = this.mainTable;
          this.mainTable
          .on( 'select', function ( e, dt, type, indexes ) {
              //var rowData = _mainTable.rows( indexes ).data().toArray();
              var rowData = _mainTable.rows( indexes ).data();

              let tab = [];
              for (let i = 0, lei = rowData[0].id.length; i < lei; i++){
                let obj = {
                  Name: rowData[0].supplier[i],
                  searchId: rowData[0].id[i]
                }
                tab.push(obj);
              }


              _vue.$store.dispatch("externalSearchResponse", tab);


          })
          .on( 'deselect', function ( e, dt, type, indexes ) {


            let tab = [];
            _vue.$store.dispatch("externalSearchResponse", tab);
          });

        },


      },



  }
</script>
<style lang="scss">
  .SearchHistoryTableComponent{

    table{
      font-size: 0.75rem;
      padding: 0px !important;
      max-width: 240px;
      margin-right: 10px;
    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/SearchHistoryTableComponent.vue